import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { BeforeAfterSlider } from './BeforeAfterSlider';
import { MarketTabs } from './MarketTabs';
import { useLanguage } from '../contexts/LanguageContext';
import { gallery } from '../data/gallery';
import { ui } from '../data/ui';
import type { Market } from '../types/content';
export function BeforeAfterGallery() {
  const {
    t
  } = useLanguage();
  const [market, setMarket] = useState<Market>('commercial');
  const g = ui.gallery;
  const items = gallery.filter(x => x.market === market);
  return <section id="gallery" className="section-y bg-mist" aria-labelledby="gallery-title" data-id="element-9" data-mp="9vegy5kp167h">
      <div className="container-page" data-id="element-10" data-mp="etppmcz95ao4">
        <SectionHeading id="gallery-title" title={t(g.title)} subtitle={t(g.subtitle)} data-id="element-11" data-mp="eqjx0nrezqnn" />
        <div className="mt-10 flex justify-center" data-id="element-12" data-mp="3w34ik4i9zrbf">
          <MarketTabs value={market} onChange={setMarket} idPrefix="gallery" label={t(g.tabsLabel)} labels={{
          commercial: t(g.tabCommercial),
          residential: t(g.tabResidential)
        }} data-id="element-13" data-mp="4tp18cmj04d2" />
        </div>
        <div id="gallery-panel" role="tabpanel" aria-labelledby={`gallery-tab-${market}`} className="mt-12" data-id="element-14" data-mp="2zr8ddp3t1j5y">
          <AnimatePresence mode="wait" initial={false} data-id="element-15" data-mp="2vpwojlsr91yt">
            <motion.div key={market} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -8
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-x-8 gap-y-12 md:grid-cols-2" data-id="element-16" data-mp="2vqepuwu9y6dl">
              {items.map(item => <BeforeAfterSlider key={item.title.en} item={item} data-id="element-17" data-mp="2c0l3iyabwjgr" />)}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}